import React, { Fragment } from 'react'
import { useStateValue } from '../state.js'
import {
  ErrorInfo,
  MetaInfo,
  PersonalInfo,
  StudentInfo,
  LaunchInfo,
  OauthInfo,
  ToolConsumerInfo,
  ContextInfo,
} from './log_infos'
import LaunchRecreation from './log_infos/LaunchRecreation.js'

const LogViewer = () => {
  const [currentState, dispatch] = useStateValue()
  let selectedLog = currentState.logs.filter(
    elem => elem.id === currentState.selectedLog
  )[0]

  return (
    <Fragment>
      <a
        onClick={() => dispatch({ type: 'selectLog', selectedLog: null })}
        className="btn btn-xs-myed btn-primary"
      >
        Go Back
      </a>
      <LaunchRecreation log={selectedLog} />
      <ErrorInfo log={selectedLog} />
      <MetaInfo log={selectedLog} />
      <PersonalInfo log={selectedLog} />
      <StudentInfo log={selectedLog} />
      <ContextInfo log={selectedLog} />
      <LaunchInfo log={selectedLog} />
      <OauthInfo log={selectedLog} />
      <ToolConsumerInfo log={selectedLog} />
      <h3>Request Body</h3>
      <pre>
        {JSON.stringify(selectedLog.params, null, 2)}
      </pre>
    </Fragment>
  )
}
export default LogViewer
